module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div>\n    <div id="pager-content" style="float:left"></div>\n    <div style="display: inline-block; padding-left: 20px;">\n        <select id="page-size" class="form-control page-sizer">\n            <option value="20"\n            ';
 if (pageSize == 20) { 
__p+=' selected ';
 } 
__p+=' >20</option>\n            <option value="50"\n            ';
 if (pageSize == 50) { 
__p+=' selected ';
 } 
__p+=' >50</option>\n            <option value="100"\n            ';
 if (pageSize == 100) { 
__p+=' selected ';
 } 
__p+=' >100</option>\n        </select>\n    </div>\n</div>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/pager/pager.html
// module id = 311
// module chunks = 0